"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toast = void 0;
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const Toast_vue_1 = tslib_1.__importDefault(require("./Toast.vue"));
exports.toast = {
    open(msg) {
        if (!msg) {
            return;
        }
        const node = new vue_1.default({
            extends: Toast_vue_1.default
        }).$mount();
        node.open(msg);
        return {
            close: node.close
        };
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O0FBQUEsc0RBQXNCO0FBQ3RCLG9FQUFnQztBQUVuQixRQUFBLEtBQUssR0FBRztJQUNqQixJQUFJLENBQUMsR0FBRztRQUNKLElBQUksQ0FBQyxHQUFHLEVBQUUsQ0FBQztZQUNQLE9BQU87UUFDWCxDQUFDO1FBRUQsTUFBTSxJQUFJLEdBQVEsSUFBSSxhQUFHLENBQUM7WUFDdEIsT0FBTyxFQUFFLG1CQUFLO1NBQ2pCLENBQUMsQ0FBQyxNQUFNLEVBQUUsQ0FBQztRQUNaLElBQUksQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUM7UUFDZixPQUFPO1lBQ0gsS0FBSyxFQUFFLElBQUksQ0FBQyxLQUFLO1NBQ3BCLENBQUM7SUFDTixDQUFDO0NBQ0osQ0FBQyJ9